module.exports = __webpack_public_path__ + "static/7-3ccfa892d2e0ef7587d75bd8d872bb71.jpg";